import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";

export async function GetBrands(payload) {
    return await axios.get(
        `${stage_url}api-business-v3/brands`,
        {
            params: payload, 
            headers: Headers.getHeaders(true),
        }
    );
}



export async function GetCategory(payload) {
    return await axios.get(
        `${stage_url}api-business-v3/categories`,
        {
            params: payload, 
            headers: Headers.getHeaders(true),
        }
    );
}

export async function addEditBrands(payload) {
    return await axios.post(
        `${stage_url}/api-business-v3/brands/brand/add-update`, payload,
        {
            headers: Headers.getDukanHeaders(true),
        }
    );
}


export async function addEditSeries(payload) {
    return await axios.post(
        `${stage_url}api-business-v3/brands/brand/series/add-update`, payload,
        {
            headers: Headers.getDukanHeaders(true),
        }
    );
}

